export default {
    path: "task",
    name: "task",
    component: () =>
        import ("@/layout/body.vue"),
    meta: [{
            title: "全部任务",
            path: "/index/task/allTask",
            icon: "el-icon-menu",
            name: "allTask",
        },
        {
            title: "正在运行",
            path: "/index/task/taskList/run",
            icon: "el-icon-refresh",
            name: "run",
        },
        {
            title: "正在等待",
            path: "/index/task/taskList/wait",
            icon: "el-icon-video-play",
            name: "wait",
        },
        {
            title: "已完成",
            path: "/index/task/taskList/success",
            icon: "el-icon-circle-check",
            name: "success",
        },
        {
            title: "已取消",
            path: "/index/task/taskList/cancel",
            icon: "el-icon-remove-outline",
            name: "cancel",
        },
        {
            title: "错误",
            path: "/index/task/taskList/error",
            icon: "el-icon-circle-close",
            name: "error",
        },
    ],
    children: [{
            path: "allTask",
            name: "allTask",
            component: () =>
                import ("@/views/task/allTask.vue"),
            meta: {
                title: "全部任务",
                parent: "任务管理",
            },
        },
        {
            path: "addTask",
            name: "addTask",
            component: () =>
                import ("@/views/task/addTask.vue"),
            meta: {
                title: "添加任务",
                parent: "任务管理",
            },
        },
        {
            path: "taskList/:type",
            name: "taskList",
            component: () =>
                import ("@/views/task/taskList.vue"),
            meta: {
                parent: "任务管理",
            },
        },
        {
            path: "detailsTask/:type/:id",
            name: "detailsTask",
            component: () =>
                import ("@/views/task/detailsTask.vue"),
            meta: {
                title: "任务详情",
                parent: "任务管理",
            },
        },
    ],
};